export const THUMB_FRAME_CLASS =
  "relative aspect-square overflow-hidden rounded-xl border border-border-secondary bg-bg-primary shadow-xs";
